import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "category-list"
};
// 定义属性
export default /*@__PURE__*/_defineComponent({
  __name: 'RoleCategoryList',
  props: {
    categoryList: {
      type: Array,
      required: true
    },
    active: {
      type: String,
      required: false,
      default: '全部'
    }
  },
  emits: ['onCategoryClick'],
  setup(__props, {
    emit: __emit
  }) {
    // 定义回调
    const emits = __emit;
    /** 处理分类点击事件 */
    const handleCategoryClick = async category => {
      emits('onCategoryClick', category);
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.categoryList, category => {
        return _openBlock(), _createElementBlock("div", {
          class: "category",
          key: category
        }, [_createVNode(_component_el_button, {
          plain: "",
          round: "",
          size: "small",
          type: category === __props.active ? 'primary' : '',
          onClick: $event => handleCategoryClick(category)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(category), 1)]),
          _: 2
        }, 1032, ["type", "onClick"])]);
      }), 128))]);
    };
  }
});